import API from '../../sunwiseAPI';

const ENTITY = 'available-bag';

export const getAvailableBag = (projectId, date) =>
    API.get(`/api/v1/${ENTITY}/${projectId}/sunpay/`, {
        params: { final_date: date },
    });
